import { render, staticRenderFns } from "./jieguo.vue?vue&type=template&id=10ff01eb&scoped=true"
import script from "./jieguo.vue?vue&type=script&lang=js"
export * from "./jieguo.vue?vue&type=script&lang=js"
import style0 from "./jieguo.vue?vue&type=style&index=0&id=10ff01eb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ff01eb",
  null
  
)

export default component.exports